module.exports = __webpack_public_path__ + "img/noinfo.860c4bef.png";